// Mapeo de rutas a nombres amigables
// Agregar nuevas rutas aquí según se vayan creando nuevas páginas

// Segmento dinámico: cuid2 (20+ alfanumérico), UUID, o slug con guiones bajos/mayúsculas (IDs de BD)
const dynamicIdRegex = /^[a-zA-Z0-9]{20,}$|^[0-9a-f-]{36}$|^[A-Z][A-Z0-9_]{2,}$/;

export const routeLabels: Record<string, string> = {
  dashboard: "Dashboard",
  users: "Usuarios",
  roles: "Roles",
  tournaments: "Torneos",
  disciplines: "Disciplinas",
  "tournament-statuses": "Estados de Torneo",
  "tournament-formats": "Eventos de Torneos",
  "tournament-format-templates": "Plantillas de Formatos",
  "sub-categories": "Subcategorías",
  "match-teams": "Equipos",
  "prize-types": "Tipos de premiación",
  "sports-predictions": "Predicciones Deportivas",
  pools: "Grupos",
  "my-pools": "Mis Grupos",
  create: "Crear",
  edit: "Editar",
};

export interface BreadcrumbItem {
  title: string;
  path?: string;
}

/**
 * Convierte una ruta en un array de breadcrumbs
 */
export function generateBreadcrumbs(pathname: string): BreadcrumbItem[] {
  const paths = pathname.split("/").filter(Boolean);
  const breadcrumbs: BreadcrumbItem[] = [];

  // Siempre agregar el inicio
  breadcrumbs.push({
    title: "Inicio",
    path: "/dashboard",
  });

  // Si estamos en dashboard, no agregar más items
  if (paths.length === 0 || (paths.length === 1 && paths[0] === "dashboard")) {
    return breadcrumbs;
  }

  // Construir breadcrumbs basados en la ruta
  let currentPath = "";
  paths.forEach((path, index) => {
    currentPath += `/${path}`;
    let isLast = index === paths.length - 1;

    if (dynamicIdRegex.test(path)) {
      return;
    }
    const nextPath = paths[index + 1] || "";
    if (path === "edit" && (dynamicIdRegex.test(nextPath) && nextPath !== "")) {
      isLast = true;
      currentPath = `${currentPath}/${nextPath}`;
    }
    // Obtener el label del mapeo o capitalizar el path
    const label = routeLabels[path] || path.charAt(0).toUpperCase() + path.slice(1);

    breadcrumbs.push({
      title: label,
      ...(isLast ? {} : { path: currentPath }),
    });
  });

  return breadcrumbs;
}
